import { getParentOfType, Instance, types, flow } from "mobx-state-tree";
import to from "await-to-js";
import { IOrderListReq } from "@/app/csr-src/apis/order/order.interface";
import { fetchOrderList } from "@/app/csr-src/apis/order/order.api";
import { withSetPropAction } from "./helpers/withSetPropAction";
import { RootStoreModel } from "./RootStore";

export const OrderItemStoreModel = types.model("OrderItemStore").props({
  id: types.string,
  name: types.string,
  isImportant: types.boolean,
});

export interface IOrderItemStore extends Instance<typeof OrderItemStoreModel> {}

export const OrderStoreModel = types
  .model("OrderStore")
  .props({
    loading: types.maybe(types.boolean),
    error: types.maybe(types.string),
    orderListInfo: types.frozen(),
    orders: types.array(OrderItemStoreModel),
    orderType: types.maybe(types.string),
    pageNum: types.maybe(types.number),
    isShowPayModal: types.optional(types.boolean, false), // 进入详情页是否展示支付弹框
  })
  .actions(withSetPropAction)
  .actions((self) => ({
    getOrderList: flow(function* (params) {
      self.loading = true;
      self.error = "";
      const requestData: IOrderListReq = { ...params };
      const [error, orderDetailData] = yield to(fetchOrderList(requestData));
      if (error) {
        self.error = error.message; // 处理错误
      } else {
        self.orderListInfo = orderDetailData; // 存储数据
      }
      self.loading = false;
    }),
    setOrderType(type: string) {
      self.orderType = type;
    },
    setPageNum(number: number) {
      self.pageNum = number;
    },
    addOrder(order: IOrderItemStore) {
      self.orders.push(order);

      // 示意跨store调用action
      getParentOfType(self, RootStoreModel).bottomBarStore.refreshOrderCount();
    },
    removeOrder(orderId: string) {
      self.orders.replace(self.orders.filter((order) => order.id !== orderId));
      getParentOfType(self, RootStoreModel).bottomBarStore.refreshOrderCount();
    },
    toggleImportant(orderId: string) {
      const order = self.orders.find((order) => order.id === orderId);
      if (order) {
        order.isImportant = !order.isImportant;
      }
    },
    setIsShowPayModal(val: boolean) {
      self.isShowPayModal = val;
    },
  }));

export interface OrdersStoreModel extends Instance<typeof OrderStoreModel> {}
